<template>
  <div class="mb-16 molecule subscribe">
    <h3 class="mb-6 text-lg font-medium text-gray-800 font-ubuntu">
      <slot name="title"> Subscribe for Updates </slot>
    </h3>
    <p class="mb-3 text-gray-500">
      <slot>
        Stay up-to-date on our newest homeowner testimonials and blog posts on
        trends and new home building topics.
      </slot>
    </p>
    <div class="relative">
      <FormsHubSpotForm :form="form" />
    </div>
  </div>
</template>

<style>
.molecule.subscribe {
  form {
    input[type="text"],
    input[type="email"] {
      @apply border border-gray-400;

      &:focus {
        @apply border-bc-blue;
      }

      &::placeholder {
        @apply text-sm;
      }
    }
  }

  .hubspot-form {
    .hs_submit {
      @apply hidden;
    }

    .hs_error_rollup {
      @apply hidden;
    }
  }
}
</style>

<script setup>
import { PaperAirplaneIcon } from "@heroicons/vue/solid/index.js";

const props = defineProps({
  molecule: Object,
});

const form = {
  id: "ddcca57e-a554-4f1e-ae26-3aca8bd11a80",
};
</script>
